import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Button, FormHelperText, Box } from '@mui/material';

import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import InputText, { InputSelectNative } from '../../common/Form';
import Creatable from '../../common/Creatable';
import PostForm from './PostForm';

class FacturePaymentForm extends Component {
    state = { 
        income_post: this.props.facture && this.props.facture.facture_post ? {
            value: this.props.facture.facture_post, 
            label: this.props.POSTS[this.props.facture.facture_post].post_name
        } : {value:"", label:""},
        income_desc: this.props.facture ? this.props.facture.facture_desc : "",
        income_ref: this.props.facture ? this.props.facture.facture_ref : "",
        income_id: "",
        income_payment_mode: "",
        income_bank: "",
        income_amount: this.props.facture ? parseFloat(this.props.facture.facture_amount) : "",
        income_files: null,
        income_date: this.props.facture ? this.props.facture.facture_date : new Date(),
        income_facture_id: this.props.facture.facture_id || "",
        
        errors: {
            income_date: "",
            income_desc: "",
            income_post: "",
            income_ref: "",
            income_payment_mode: "",
            income_bank: "",
            income_amount: "",
            income_files: "",
        },
        incomeList: [],
        available: ""
        
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value
        })        
    }

    handleChangeDate = (date) => {
        this.setState({
            income_date: date
        })
    }
    handleChangeSelect = (option, name) => {
        if(option){
            this.setState({
                [name]: option
            })
        } else {
            this.setState({
                [name]: {}
            })
        }
    }
    createNew = (field, name) => {
        this.setState({
            [field]: true,
            nameNew: name
        })
    }
    setFiles = (income_files, error = "") => {
        console.log("[INFO] SET_PHOTO", income_files);
        this.setState({
            income_files,
            errors:{
                ...this.state.errors,
                income_files:error
            }
        })
    }
    validate = () => {
        let required = [
            "income_post",
            "income_amount",
            "income_ref",
            "income_desc",
            "income_payment_mode",
            "income_bank",
            "income_files"
        ]
        if (this.props.update){
            required = [
                "income_post",
                "income_amount",
                "income_ref",
                "income_desc",
                "income_payment_mode",
                "income_bank",
            ]
        }
        
        let noError = true
        let errors = {}
        
        required.map(field => {
            if( isEmpty(this.state[field]) && !this.state[field] ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else if( field === "income_post" && isEmpty(this.state[field].value)){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        
        this.setState({
            errors
        })
        
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            
            data.income_files =  this.state.income_files
            data.income_amount =  parseFloat(this.state.income_amount)
            data.income_payment_mode = this.state.income_payment_mode
            data.income_bank =  this.state.income_bank
            data.income_post =  this.state.income_post.value
            data.income_ref =  this.state.income_ref
            data.income_date =  this.state.income_date
            data.income_desc =  this.state.income_desc
            data.income_facture_id =  this.state.income_facture_id
            
            
            console.log('====================================');
            console.log("submit income", {data});
            console.log('====================================');
            
            await this.props.newIncome(data)

            // // if NoErrors ...
            if(this.props.STATE.incomes.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.incomes.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { BANKS, POSTS, STATE } = this.props;
        const { nameNew, formPost} = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth= "md"
                scroll="body"
            >
                {formPost &&
                    <PostForm
                        POSTS={POSTS}
                        STATE={STATE}
                        post={{post_name: nameNew}}
                        handleClose={() => this.setState({ formPost: false, nameNew: "" })}
                        newPost={this.props.newPost}
                        notif={this.props.notif}
                    />
                }
                <DialogTitle id="form-dialog-title">Ajouter une recette</DialogTitle>
                <DialogContent>
                    <Grid container >
                        <Grid sm={6} xs ={12}>
                            <DatePicker  
                                id="income_date" 
                                label="Date" 
                                name="income_date" 
                                value={this.state.income_date} 
                                handleChange={this.handleChangeDate} 
                                error={this.state.errors.income_date}
                                required
                            />      
                            <Creatable
                                required
                                label="Poste"
                                error={this.state.errors.income_post}
                                id="income_post"
                                options={Object.values(POSTS).map( item => ({
                                    label: item.post_name,
                                    value: item.post_id
                                }))}
                                value={this.state.income_post}
                                openPopUp={(name) => this.createNew("formPost", name)}
                                onChange={(option) => this.handleChangeSelect(option, "income_post" )}
                            />
                            
                            <InputSelectNative
                                label="Banque"
                                onChange={this.handleChange}
                                error={this.state.errors.income_bank}
                                value={this.state.income_bank}
                                labelWidth={60} 
                                name="income_bank" 
                                id="income_bank" 
                                options={ Object.values(BANKS).map( bank  => (
                                    <option value={bank.bank_id} key={bank.bank_id}>
                                        {bank.bank_name}
                                    </option>
                                )) }
                            />
                            <InputSelectNative
                                label="Mode de Paiement"
                                value={this.state.income_payment_mode}
                                onChange={this.handleChange}
                                labelWidth={170} 
                                name="income_payment_mode" id="income_payment_mode"
                                error={this.state.errors.income_payment_mode} 
                                options={[
                                    <option value="ESPECES">ESPECES</option>,
                                    <option value="CHEQUE">CHEQUE</option>,
                                    <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                    <option value="VIREMENT">VIREMENT</option>,
                                    <option value="GAB">GAB</option>,
                                    <option value="MOBILE MONEY">MOBILE MONEY</option>
                                ]}
                            />
                            
                            
                        </Grid>
                        <Grid sm={6} xs ={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="income_desc"
                                error={this.state.errors.income_desc}
                                value={this.state.income_desc}
                                name="income_desc"
                                label="Description"
                                rows={5}
                                multiline
                            />
                            
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="income_amount"
                                error={this.state.errors.income_amount}
                                value={this.state.income_amount}
                                name="income_amount"
                                label="Montant"
                                type="number"          
                            />
                            
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="income_ref"
                                error={this.state.errors.income_ref}
                                value={this.state.income_ref}
                                name="income_ref"
                                label="Référence"
                            />
                        </Grid>
                    </Grid>
                    {!this.props.update &&
                        <Box p={1}>
                            <FileUpload
                                label="Ajouter un Justificatif"
                                setFiles={this.setFiles} 
                                files={this.state.income_files || []} 
                            />
                            <FormControl error={!!this.state.errors.income_files} >
                                <br/>
                                <FormHelperText >{this.state.errors.income_files}</FormHelperText>
                            </FormControl>
                        </Box>
                    }
                    
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary">
                        Valider
                    </Button>
                    <Button onClick={this.props.handleClose} >
                        Annuler
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default FacturePaymentForm;